<div>
  @if (data !== undefined) {
    <span>{{ data.name }}</span>
  }
</div>
